/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DragAndDropErrorComponent} from './drag-and-drop-error.component';

@NgModule({
    declarations: [DragAndDropErrorComponent],
    exports: [
        DragAndDropErrorComponent
    ],
    imports: [
        CommonModule
    ]
})
export class DragAndDropErrorModule {
}
